export default {
	/**
	 * Set all subscriber fields
	 * @param {Array} subscriberFields 
	 */
	setSubscriberFields(state, subscriberFields) {
		state.all = subscriberFields
	},
}
